import lodash from "lodash";
import { matchRoutes } from "react-router";
import ApiService from "./ApiService";
import { confirmDialog } from 'primereact/confirmdialog'; // For confirmDialog method
import { Button } from "primereact/button";
class utilService {
    async confirm(mensagem){
        return new Promise((resolve) => {
            confirmDialog({
                message: mensagem || 'Tem certeza que deseja prosseguir?',
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                defaultFocus: 'accept',
                acceptLabel: "Sim",
                rejectLabel: "Não",
                accept: () => { resolve({ status: true }) },
                reject: () => { resolve({ status: false }) }
            });
        });
    }
    baixarNf(fatura){
        const url = ApiService.urlBase + "/hay/clienteContrato/retornarNotaFiscal?idfatura=" + fatura.idfatura;
        window.open(url, "_blank");
        this.showToast({ severity: 'warn', summary: 'Link aberto', detail: 'Abrimos o link em uma nova aba' });
    }
    abrirLink(link) {
        window.open(link, "_blank");
        this.showToast({ severity: 'warn', summary: 'Link aberto', detail: 'Abrimos o link em uma nova aba' });
    }
    copiarInformacao(informacao) {
        try{
            window.navigator.clipboard.writeText(informacao);
            this.showToast({ severity: 'success', summary: 'Informação copiada!', detail: 'Informação copiada para Área de Transferencia. Voce pode agora colar no seu aplicativo de pagamentos preferido.' });
            return true;
        } catch(ex){
            this.showToast({ severity: 'warn', summary: 'Informação não copiada!', detail: 'Não conseguimos copiar a informação. Verifique se está usando acesso seguro (HTTPS)' });
            return false;
        }
    }
    urlRegistrada(rotas, path) {
        const urlExiste = matchRoutes(rotas, path || "não", "/");
        if (urlExiste){
            const ultima = lodash.last(urlExiste);
            return ultima.route.path !== "/*"; // Se nao pegou a default, existe....
        } 
        return false; // nada é nada
    }
    getParam(prm, prms) {  
        return prms?.get && prms?.get(prm); 
    }
    getUrlParams(field) {
        return new URLSearchParams(window.location.search).get(field);
    }
    getAllParams(){
        return Object.fromEntries(new URLSearchParams(window.location.search));
    }
    formatCurrency(value) {
        if (value){
            return value.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' });
        }
        return "R$ 0,00";
        
    }
    reactVisibility(teste) {
        if (!teste) {
            return { visibility: 'hidden' };
        }
        return { visibility: 'visible' };
    }
    reactShow(teste) {
        if (!teste) {
            return { display: 'none' };
        }
        return { display: 'flex' };
    }
    reactShowInline(teste) {
        if (!teste) {
            return { display: 'none' };
        }
        return { display: 'inline-block' };
    }
    reactEnabled(teste) {
        if (!teste) {
            return { opacity: 0.7, pointerEvents: 'none'};
        }
        return { opacity: 1  };
    }
    showAlert(mensagem, titulo) {
        var event = new CustomEvent("showAlert", { detail: { mensagem, titulo } });
        window.dispatchEvent(event);
    }
    hideAlert(mensagem) {
        var event = new CustomEvent("hideAlert", { detail: { mensagem } });
        window.dispatchEvent(event);
    }
    showToast(dados) {
        var event = new CustomEvent("showToast", { detail: dados });
        window.dispatchEvent(event);
    }
    hideToast(dados) {
        var event = new CustomEvent("hideToast", { detail: dados });
        window.dispatchEvent(event);
    }
    showLoading(mensagem, cbCancelamento) {
        var event = new CustomEvent("showLoading", { detail: { mensagem , cbCancelamento } });
        window.dispatchEvent(event);
    }
    hideLoading () {
        var event = new CustomEvent("hideLoading", {  });
        window.dispatchEvent(event);
    }
    async setState (newState, contexto) {
        try {
            return new Promise(resolve => contexto.setState(newState, resolve));
        } catch (err) {
            console.log(err);
        }
    }
    async aguardar (tempo) {
        try {
            return new Promise((resolve) => setTimeout(resolve, tempo));
        } catch (err) {
            console.log(err);
        }
    }
    aguardarCb (tempo, cb) {
        return setTimeout(cb, tempo);
    }
    async iniciarTimerSessao (aoTerminar, toast) {
        var tempo = 120000;
        if (utilService.timeoutSessaoId){
            clearTimeout(utilService.timeoutSessaoId);
        }
        const tempoFormatado = tempo / 1000;
        toast.warn('Para sua segurança, sua sessão será terminada em '+ tempoFormatado +' segundos...', {
            toastId: "identificador-sessao",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: null,
            theme: "colored",
            onClose: aoTerminar,
            progress: 1,
            position: "bottom-right",
        });

        return await utilService.contagemRegressiva(tempo, (tempoAtualizado) => {
            const tempoFormatado = tempoAtualizado / 1000;
            const mesg = 'Para sua segurança, sua sessão será terminada em '+ tempoFormatado +' segundos...';
            const percentual = tempoAtualizado / tempo;
            toast.update("identificador-sessao", {  
                render: mesg,
                progress: percentual,
                onClose: aoTerminar,
            });
        }, ()=> {
            toast.dismiss("identificador-sessao");
        });
    }
    async  contagemRegressiva (tempo, fnUpdate, fnFinal) {
        if (tempo > 0){            
            utilService.timeoutSessaoId = utilService.aguardarCb(1000, async () => {
                tempo -= 1000;
                fnUpdate(tempo);
                return await utilService.contagemRegressiva(tempo, fnUpdate, fnFinal);
            });
        } else {
            return fnFinal();
        }
    }
    formatCpfCnpj(input) {
        if (String(input).length > 11){
            var str = input + '';
            str = str.replace(/\D/g, '');
            str = str.replace(/^(\d{2})(\d)/, '$1.$2');
            str = str.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
            str = str.replace(/\.(\d{3})(\d)/, '.$1/$2');
            str = str.replace(/(\d{4})(\d)/, '$1-$2');
            return str;        
        }
        else{
            var str = input + '';
            str = str.replace(/\D/g, '');
            str = str.replace(/(\d{3})(\d)/, '$1.$2');
            str = str.replace(/(\d{3})(\d)/, '$1.$2');
            str = str.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
            return str;
        }    
    }
    removerCaracteresCpfCnpj(cpfCnpj){
        return lodash.replace(lodash.trim(cpfCnpj), /[\/\\\.\,\- \ ]/g, '');
    }  
    validarEsquema(esquema, dados, erros) {
        lodash.forOwn(erros, function(valor, erro){
            erros[erro] = "";
        });
        erros.valido = true;
        lodash.forOwn(esquema, function(validacoes, atributo){
            lodash.forOwn(validacoes, function( validacao, regra){
                switch(regra){
                    case "strictobrigatorio":
                        if (dados[atributo] === undefined  || dados[atributo] === null ){ // Se nao estiver preenchido
                            if (!erros[atributo]){ // um erro por vez...
                                erros[atributo] =  "Este campo é Obrigatório."
                                erros.valido = false;
                                if (validacoes.onError){
                                    validacoes.onError(erros[atributo]);
                                }
                            }
                        }
                    break;
                    case "obrigatorio":
                        if (!dados[atributo] || dados[atributo].length === 0){ // Se nao estiver preenchido
                            if (!erros[atributo]){ // um erro por vez...
                                erros[atributo] =  "Este campo é Obrigatório."
                                erros.valido = false;
                                if (validacoes.onError){
                                    validacoes.onError(erros[atributo]);
                                }
                            }
                        }
                    break;
                    case "identico":
                        if (dados[atributo]){ // Se estiver preenchido
                            if (dados[atributo] != dados[validacao.campo]){
                                if (!erros[atributo]){ // um erro por vez...
                                    erros[atributo] =  "Este campo é deve ser igual ao campo " + validacao.descricao;
                                    erros.valido = false; 
                                    if (validacoes.onError){
                                        validacoes.onError(erros[atributo]);
                                    }
                                }
                            }
                        }
                    case "tamanhominimo":
                        if (dados[atributo]){ // Se estiver preenchido
                            if (dados[atributo].length < validacao ){
                                if (!erros[atributo]){ // um erro por vez...
                                    erros[atributo] =  "Este campo não pode ter menos de " + validacao + " caracteres.";
                                    erros.valido = false; 
                                    if (validacoes.onError){
                                        validacoes.onError(erros[atributo]);
                                    }
                                }
                            }
                        }
                    break;
                    case "tamanhomaximo":
                        if (dados[atributo]){ // Se estiver preenchido
                            if (dados[atributo].length > validacao ){
                                if (!erros[atributo]){ // um erro por vez...
                                    erros[atributo] =  "Este campo não pode ter mais de " + validacao + " caracteres.";
                                    erros.valido = false; 
                                    if (validacoes.onError){
                                        validacoes.onError(erros[atributo]);
                                    }
                                }
                            }
                        }
                    break;                    
                    case "caracterespecial":
                        const caracterespecial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
                        if (dados[atributo]){ // Se estiver preenchido
                            if (!caracterespecial.test(dados[atributo])){
                                if (!erros[atributo]){ // um erro por vez...
                                    erros[atributo] =  "Este campo precisa ter pelo menos um caracter especial. Caracteres válidos: [`!@#$%^&*()_+-=[]{};':\\|,.<>\/?~].";
                                    erros.valido = false; 
                                    if (validacoes.onError){
                                        validacoes.onError(erros[atributo]);
                                    }
                                }
                            }
                        }
                    break;
                    case "maiusculaminuscula":
                        const maiusculaminuscula = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
                        if (dados[atributo]){ // Se estiver preenchido
                            if (!maiusculaminuscula.test(dados[atributo])){
                                if (!erros[atributo]){ // um erro por vez...
                                    erros[atributo] =  "Este campo precisa ter pelo menos uma letra minuscula e uma maiúscula.";
                                    erros.valido = false; 
                                    if (validacoes.onError){
                                        validacoes.onError(erros[atributo]);
                                    }
                                }
                            }
                        }
                    case "pelomenosumdigito":
                        const pelomenosumdigito = /^(?=.*\d).+$/;
                        if (dados[atributo]){ // Se estiver preenchido
                            if (!pelomenosumdigito.test(dados[atributo])){
                                if (!erros[atributo]){ // um erro por vez...
                                    erros[atributo] =  "Este campo precisa ter pelo menos um digito.";
                                    erros.valido = false; 
                                    if (validacoes.onError){
                                        validacoes.onError(erros[atributo]);
                                    }
                                }
                            }
                        }
                    break;
                }
            });
        });
        return erros;
    }
    retornaSituacao(state){
        switch(state){
            case "main.clientecontrato.aguardando.conexao":
                return "Aguardando Conexão";
            case "main.clientecontrato.conectado.ativo":
                return "Conectado Ativo";
            case "main.clientecontrato.pausado":
                return "Pausado";
            case "main.clientecontrato.inadimplente":
                return "Inadimplente";
            case "main.clientecontrato.cancelado":
                return "Cancelado";
            case "main.clientecontrato.sem.cabeamento":
                return "Sem Cabeamento";
            case "main.clientecontrato.conectado.inadimplente":
                return "Conectado/Inadimplente";
        }
    }
}

export default new utilService();